import { UNIT_SYSTEM } from '../../shared/config/hydraulics_constants';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../utils/constants';

const columns = (renderActions, renderValueCell, renderValueTextCell, drillStringUnit, currentUnit) => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueTextCell,
    editable: true,
    headerAlign: 'center',
    align: 'center'
  },
  {
    field: 'MD',
    headerName: `MD (${drillStringUnit?.MD?.label})`,
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return currentUnit !== UNIT_SYSTEM.US ? value : value.toFixed(drillStringUnit?.MD.decimals);
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: 280,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  },
];
export default columns;
